import * as React from "react"

export default function ListNumber(props) {
  switch (props.number) {
    case 1:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.210001 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.10368 11.01C0.403679 13.41 -1.19631 21.01 0.803691 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.5037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M22.3001 22.6L19.4001 23.5C19.1001 23.3 18.8001 23 18.5001 22.7C18.2001 22.3 18.1001 21.9 18.1001 21.2C18.1001 20 18.8001 19.2 20.2001 18.7L23.5001 17.6H24.6001C25.4001 17.6 26.1001 17.8 26.6001 18.3C27.1001 18.8 27.3001 19.5 27.3001 20.3V35.6C27.1001 35.6 26.8001 35.7 26.3001 35.8C25.9001 35.9 25.5001 35.9 25.0001 35.9C24.6001 35.9 24.2001 35.9 23.8001 35.8C23.5001 35.7 23.2001 35.6 22.9001 35.4C22.7001 35.2 22.5001 35 22.4001 34.7C22.3001 34.4 22.2001 34 22.2001 33.5V22.6H22.3001Z"
            fill="#3B180F"
          />
          <path
            d="M24.5002 14.9C24.3002 14.9 24.2002 14.8 24.2002 14.6V12.3C24.2002 12.1 24.3002 12 24.5002 12C24.7002 12 24.8002 12.1 24.8002 12.3V14.6C24.8002 14.8 24.7002 14.9 24.5002 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.6998 18.7C33.5998 18.7 33.4998 18.7 33.4998 18.6C33.3998 18.5 33.3998 18.3 33.4998 18.2L35.0998 16.6C35.1998 16.5 35.3998 16.5 35.4998 16.6C35.5998 16.7 35.5998 16.9 35.4998 17L33.8998 18.6C33.8998 18.7 33.7998 18.7 33.6998 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8002 27.9H37.5002C37.3002 27.9 37.2002 27.8 37.2002 27.6C37.2002 27.4 37.3002 27.3 37.5002 27.3H39.8002C40.0002 27.3 40.1002 27.4 40.1002 27.6C40.1002 27.8 40.0002 27.9 39.8002 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.3C9.1 27.9 9 27.8 9 27.6C9 27.4 9.1 27.3 9.3 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.7 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.4999 18.7 15.3999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 2:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.210001 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.1037 11.01C0.403704 13.41 -1.19631 21.01 0.803686 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.4037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M23.0004 17.4C24.1004 17.4 25.1004 17.5 26.0004 17.8C26.9004 18.1 27.6004 18.5 28.2004 19C28.8004 19.5 29.3004 20.1 29.6004 20.7C29.9004 21.4 30.1004 22.1 30.1004 22.8C30.1004 24.8 28.9004 26.8 26.6004 28.7L22.8004 31.8H29.8004C29.9004 32 30.0004 32.3 30.1004 32.6C30.2004 32.9 30.3004 33.3 30.3004 33.7C30.3004 34.4 30.1004 34.9 29.8004 35.2C29.5004 35.5 29.1004 35.7 28.6004 35.7H18.3004C17.9004 35.4 17.5004 35 17.3004 34.6C17.1004 34.1 16.9004 33.6 16.9004 33C16.9004 32.3 17.0004 31.8 17.3004 31.3C17.6004 30.8 17.9004 30.5 18.2004 30.2L22.2004 26.7C22.7004 26.3 23.1004 25.9 23.5004 25.5C23.8004 25.2 24.1004 24.9 24.3004 24.6C24.5004 24.3 24.7004 24.1 24.7004 23.8C24.8004 23.6 24.8004 23.3 24.8004 23.1C24.8004 22.6 24.6004 22.1 24.1004 21.8C23.6004 21.5 23.0004 21.3 22.3004 21.3C21.5004 21.3 20.8004 21.4 20.2004 21.7C19.6004 21.9 19.1004 22.2 18.7004 22.5C18.4004 22.3 18.1004 22 17.9004 21.6C17.7004 21.2 17.6004 20.8 17.6004 20.4C17.6004 19.4 18.1004 18.6 19.0004 18.1C20.1004 17.7 21.4004 17.4 23.0004 17.4Z"
            fill="#3B180F"
          />
          <path
            d="M24.5998 14.9C24.3998 14.9 24.2998 14.8 24.2998 14.6V12.3C24.2998 12.1 24.3998 12 24.5998 12C24.7998 12 24.8998 12.1 24.8998 12.3V14.6C24.8998 14.8 24.7998 14.9 24.5998 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.7999 18.7C33.6999 18.7 33.5999 18.7 33.5999 18.6C33.4999 18.5 33.4999 18.3 33.5999 18.2L35.1999 16.6C35.2999 16.5 35.4999 16.5 35.5999 16.6C35.6999 16.7 35.6999 16.9 35.5999 17L33.9999 18.6C33.8999 18.7 33.8999 18.7 33.7999 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8998 27.9H37.5998C37.3998 27.9 37.2998 27.8 37.2998 27.6C37.2998 27.4 37.3998 27.3 37.5998 27.3H39.8998C40.0998 27.3 40.1998 27.4 40.1998 27.6C40.1998 27.8 40.0998 27.9 39.8998 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.29999C9.09999 27.9 9 27.8 9 27.6C9 27.4 9.09999 27.3 9.29999 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.8 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.5999 18.7 15.4999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 3:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.209999 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.10368 11.01C0.403679 13.41 -1.19631 21.01 0.803691 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.5037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M22.7 17.4C24.9 17.4 26.7 17.9 27.8 18.8C29 19.7 29.6 21 29.6 22.5C29.6 23.4 29.4 24.2 28.9 24.9C28.4 25.6 27.8 26 27.1 26.4C27.5 26.6 27.9 26.8 28.2 27C28.6 27.2 28.9 27.5 29.1 27.9C29.4 28.3 29.6 28.7 29.7 29.1C29.9 29.6 29.9 30.1 29.9 30.7C29.9 31.5 29.7 32.3 29.4 33C29 33.7 28.5 34.2 27.9 34.7C27.3 35.2 26.5 35.5 25.6 35.8C24.7 36 23.7 36.2 22.7 36.2C20.7 36.2 19.1 35.9 18.1 35.4C17.1 34.8 16.5 34.1 16.5 33.2C16.5 32.7 16.6 32.2 16.9 31.8C17.2 31.4 17.5 31.1 17.8 30.9C18.2 31.2 18.7 31.5 19.4 31.8C20.1 32.1 20.9 32.3 22 32.3C23 32.3 23.7 32.1 24.2 31.8C24.7 31.4 24.9 31 24.9 30.4C24.9 29.8 24.7 29.4 24.3 29.1C23.9 28.8 23.3 28.7 22.3 28.7H19.5C19.4 28.5 19.2 28.2 19.1 27.9C19 27.6 19 27.2 19 26.8C19 26.4 19 26 19.1 25.6C19.2 25.3 19.3 25 19.5 24.8H22.3C23.7 24.8 24.4 24.3 24.4 23.2C24.4 22.7 24.2 22.3 23.7 22C23.3 21.7 22.6 21.5 21.7 21.5C20.9 21.5 20.2 21.6 19.6 21.8C19 22 18.5 22.2 18.1 22.5C17.8 22.3 17.5 22 17.3 21.6C17.1 21.3 17 20.9 17 20.4C17 19.4 17.5 18.7 18.5 18.2C19.7 17.7 21 17.4 22.7 17.4Z"
            fill="#3B180F"
          />
          <path
            d="M24.5002 14.9C24.3002 14.9 24.2002 14.8 24.2002 14.6V12.3C24.2002 12.1 24.3002 12 24.5002 12C24.7002 12 24.8002 12.1 24.8002 12.3V14.6C24.8002 14.8 24.7002 14.9 24.5002 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.6998 18.7C33.5998 18.7 33.4998 18.7 33.4998 18.6C33.3998 18.5 33.3998 18.3 33.4998 18.2L35.0998 16.6C35.1998 16.5 35.3998 16.5 35.4998 16.6C35.5998 16.7 35.5998 16.9 35.4998 17L33.8998 18.6C33.8998 18.7 33.7998 18.7 33.6998 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8002 27.9H37.5002C37.3002 27.9 37.2002 27.8 37.2002 27.6C37.2002 27.4 37.3002 27.3 37.5002 27.3H39.8002C40.0002 27.3 40.1002 27.4 40.1002 27.6C40.1002 27.8 40.0002 27.9 39.8002 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.3C9.1 27.9 9 27.8 9 27.6C9 27.4 9.1 27.3 9.3 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.7 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.4999 18.7 15.3999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 4:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.209999 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.1037 11.01C0.403704 13.41 -1.19631 21.01 0.803686 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.4037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M23.1004 18.1C23.5004 18 23.9004 17.9 24.4004 17.8C24.9004 17.7 25.3004 17.7 25.7004 17.7C26.1004 17.7 26.6004 17.7 27.0004 17.8C27.4004 17.9 27.8004 18 28.1004 18.2C28.4004 18.4 28.7004 18.7 28.9004 19C29.1004 19.4 29.2004 19.8 29.2004 20.3V28.1H31.8004C31.9004 28.3 32.0004 28.6 32.2004 28.9C32.3004 29.3 32.4004 29.6 32.4004 30C32.4004 30.7 32.2004 31.3 31.9004 31.6C31.6004 31.9 31.1004 32.1 30.6004 32.1H29.2004V35.6C29.0004 35.6 28.7004 35.7 28.2004 35.8C27.8004 35.9 27.4004 35.9 27.0004 35.9C26.6004 35.9 26.2004 35.9 25.9004 35.8C25.6004 35.8 25.3004 35.7 25.1004 35.5C24.9004 35.3 24.7004 35.1 24.6004 34.9C24.5004 34.6 24.4004 34.3 24.4004 33.8V32.2H17.1004C16.7004 32 16.3004 31.6 15.9004 31.2C15.6004 30.7 15.4004 30.2 15.4004 29.5C15.4004 29.1 15.4004 28.7 15.5004 28.3C15.6004 27.9 15.8004 27.5 16.0004 27.1L23.1004 18.1ZM24.6004 22.7L20.6004 28.2H24.6004V22.7Z"
            fill="#3B180F"
          />
          <path
            d="M24.5998 14.9C24.3998 14.9 24.2998 14.8 24.2998 14.6V12.3C24.2998 12.1 24.3998 12 24.5998 12C24.7998 12 24.8998 12.1 24.8998 12.3V14.6C24.8998 14.8 24.7998 14.9 24.5998 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.7999 18.7C33.6999 18.7 33.5999 18.7 33.5999 18.6C33.4999 18.5 33.4999 18.3 33.5999 18.2L35.1999 16.6C35.2999 16.5 35.4999 16.5 35.5999 16.6C35.6999 16.7 35.6999 16.9 35.5999 17L33.9999 18.6C33.8999 18.7 33.8999 18.7 33.7999 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8998 27.9H37.5998C37.3998 27.9 37.2998 27.8 37.2998 27.6C37.2998 27.4 37.3998 27.3 37.5998 27.3H39.8998C40.0998 27.3 40.1998 27.4 40.1998 27.6C40.1998 27.8 40.0998 27.9 39.8998 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.29999C9.09999 27.9 9 27.8 9 27.6C9 27.4 9.09999 27.3 9.29999 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.8 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.5999 18.7 15.4999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 5:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.209999 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.10368 11.01C0.403679 13.41 -1.19631 21.01 0.803691 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.5037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M23.2003 36.1C22.3003 36.1 21.5003 36 20.8003 35.9C20.1003 35.8 19.4003 35.6 18.9003 35.3C18.4003 35 18.0003 34.7 17.7003 34.3C17.4003 33.9 17.3003 33.4 17.3003 32.9C17.3003 32.4 17.5003 31.9 17.8003 31.5C18.1003 31.1 18.5003 30.8 18.9003 30.6C19.4003 31 20.0003 31.4 20.7003 31.7C21.3003 32 22.1003 32.2 23.1003 32.2C24.0003 32.2 24.7003 32 25.1003 31.6C25.5003 31.2 25.7003 30.7 25.7003 30.1C25.7003 29.5 25.5003 29.1 25.2003 28.7C24.9003 28.3 24.3003 28.1 23.4003 28.1C22.9003 28.1 22.4003 28.2 22.1003 28.3C21.7003 28.4 21.3003 28.6 20.9003 28.8C19.9003 28.8 19.2003 28.5 18.6003 28C18.0003 27.5 17.8003 26.8 17.8003 25.8C17.8003 25.7 17.8003 25.7 17.8003 25.6C17.8003 25.5 17.8003 25.3 17.8003 25.1L18.2003 20.6C18.3003 19.8 18.5003 19.1 19.0003 18.6C19.5003 18.1 20.1003 17.9 21.0003 17.9H29.4003C29.5003 18.1 29.6003 18.4 29.8003 18.7C29.9003 19.1 30.0003 19.4 30.0003 19.8C30.0003 20.5 29.8003 21.1 29.5003 21.4C29.2003 21.7 28.7003 21.9 28.2003 21.9H22.6003L22.4003 24.7C22.8003 24.6 23.1003 24.5 23.5003 24.4C23.9003 24.3 24.4003 24.3 24.9003 24.3C25.9003 24.3 26.8003 24.5 27.5003 24.8C28.2003 25.1 28.9003 25.5 29.3003 26C29.8003 26.5 30.1003 27.1 30.4003 27.8C30.6003 28.5 30.7003 29.3 30.7003 30.1C30.7003 30.9 30.6003 31.7 30.3003 32.4C30.0003 33.1 29.6003 33.8 29.0003 34.3C28.4003 34.9 27.7003 35.3 26.8003 35.6C25.6003 36 24.5003 36.1 23.2003 36.1Z"
            fill="#3B180F"
          />
          <path
            d="M24.5002 14.9C24.3002 14.9 24.2002 14.8 24.2002 14.6V12.3C24.2002 12.1 24.3002 12 24.5002 12C24.7002 12 24.8002 12.1 24.8002 12.3V14.6C24.8002 14.8 24.7002 14.9 24.5002 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.6998 18.7C33.5998 18.7 33.4998 18.7 33.4998 18.6C33.3998 18.5 33.3998 18.3 33.4998 18.2L35.0998 16.6C35.1998 16.5 35.3998 16.5 35.4998 16.6C35.5998 16.7 35.5998 16.9 35.4998 17L33.8998 18.6C33.8998 18.7 33.7998 18.7 33.6998 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8002 27.9H37.5002C37.3002 27.9 37.2002 27.8 37.2002 27.6C37.2002 27.4 37.3002 27.3 37.5002 27.3H39.8002C40.0002 27.3 40.1002 27.4 40.1002 27.6C40.1002 27.8 40.0002 27.9 39.8002 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.3C9.1 27.9 9 27.8 9 27.6C9 27.4 9.1 27.3 9.3 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.7 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.4999 18.7 15.3999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 6:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.209999 29.6037 -0.99 22.9037 0.81C13.6037 3.21 13.8037 8.61 7.1037 11.01C0.403704 13.41 -1.19631 21.01 0.803686 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.81 40.4037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M29.6 20C29.6 20.4 29.5 20.8 29.3 21.2C29.1 21.6 28.9 21.9 28.6 22.1C28.1 21.9 27.5 21.7 26.9 21.6C26.3 21.5 25.8 21.4 25.3 21.4C24.1 21.4 23.2 21.7 22.6 22.3C22 22.9 21.5 23.8 21.3 24.9C21.7 24.6 22.2 24.4 22.9 24.2C23.5 24 24.2 23.9 24.9 23.9C26.7 23.9 28.1 24.4 29.2 25.5C30.3 26.5 30.8 28 30.8 30C30.8 30.8 30.7 31.6 30.4 32.4C30.1 33.2 29.7 33.8 29.1 34.4C28.5 35 27.8 35.4 26.9 35.8C26 36.1 25 36.3 23.9 36.3C21.6 36.3 19.8 35.5 18.5 34C17.2 32.5 16.5 30.3 16.5 27.4C16.5 25.8 16.7 24.4 17.1 23.1C17.5 21.9 18.1 20.8 18.8 20C19.5 19.2 20.4 18.6 21.4 18.2C22.4 17.8 23.5 17.6 24.8 17.6C26.4 17.6 27.6 17.8 28.4 18.2C29.1 18.5 29.6 19.2 29.6 20ZM23.8 27.7C23.4 27.7 23 27.8 22.6 27.9C22.2 28.1 21.8 28.3 21.6 28.5V29.2C21.6 30.3 21.8 31 22.3 31.5C22.7 31.9 23.3 32.2 23.9 32.2C24.5 32.2 25 32 25.3 31.6C25.6 31.2 25.8 30.6 25.8 29.9C25.8 29.2 25.6 28.7 25.3 28.3C25 27.9 24.5 27.7 23.8 27.7Z"
            fill="#3B180F"
          />
          <path
            d="M24.5998 14.9C24.3998 14.9 24.2998 14.8 24.2998 14.6V12.3C24.2998 12.1 24.3998 12 24.5998 12C24.7998 12 24.8998 12.1 24.8998 12.3V14.6C24.8998 14.8 24.7998 14.9 24.5998 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.7999 18.7C33.6999 18.7 33.5999 18.7 33.5999 18.6C33.4999 18.5 33.4999 18.3 33.5999 18.2L35.1999 16.6C35.2999 16.5 35.4999 16.5 35.5999 16.6C35.6999 16.7 35.6999 16.9 35.5999 17L33.9999 18.6C33.8999 18.7 33.8999 18.7 33.7999 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8998 27.9H37.5998C37.3998 27.9 37.2998 27.8 37.2998 27.6C37.2998 27.4 37.3998 27.3 37.5998 27.3H39.8998C40.0998 27.3 40.1998 27.4 40.1998 27.6C40.1998 27.8 40.0998 27.9 39.8998 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.29999C9.09999 27.9 9 27.8 9 27.6C9 27.4 9.09999 27.3 9.29999 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.8 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.5999 18.7 15.4999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 7:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.210005 29.6037 -0.990001 22.9037 0.809999C13.6037 3.21 13.8037 8.61001 7.10368 11.01C0.403679 13.41 -1.19631 21.01 0.803691 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.91 40.5037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M29 17.9C29.3 18.1 29.6 18.4 29.9 18.8C30.2 19.2 30.3 19.7 30.3 20.2C30.3 20.5 30.3 20.8 30.2 21.2C30.1 21.5 30 21.8 29.9 22.2L23.8 36C23.5 36 23.3 36 23 36C22.8 36 22.5 36 22.3 36C21.4 36 20.7 35.8 20.2 35.5C19.7 35.2 19.4 34.6 19.4 33.8C19.4 33.4 19.5 32.9 19.7 32.5C19.9 32 20.2 31.5 20.5 30.8L24.8 22H17.6C17.5 21.8 17.4 21.5 17.2 21.2C17.1 20.8 17 20.5 17 20.1C17 19.4 17.2 18.8 17.5 18.5C17.8 18.2 18.3 18 18.8 18H29V17.9Z"
            fill="#3B180F"
          />
          <path
            d="M24.5002 14.9C24.3002 14.9 24.2002 14.8 24.2002 14.6V12.3C24.2002 12.1 24.3002 12 24.5002 12C24.7002 12 24.8002 12.1 24.8002 12.3V14.6C24.8002 14.8 24.7002 14.9 24.5002 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.6998 18.7C33.5998 18.7 33.4998 18.7 33.4998 18.6C33.3998 18.5 33.3998 18.3 33.4998 18.2L35.0998 16.6C35.1998 16.5 35.3998 16.5 35.4998 16.6C35.5998 16.7 35.5998 16.9 35.4998 17L33.8998 18.6C33.8998 18.7 33.7998 18.7 33.6998 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8002 27.9H37.5002C37.3002 27.9 37.2002 27.8 37.2002 27.6C37.2002 27.4 37.3002 27.3 37.5002 27.3H39.8002C40.0002 27.3 40.1002 27.4 40.1002 27.6C40.1002 27.8 40.0002 27.9 39.8002 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.3C9.1 27.9 9 27.8 9 27.6C9 27.4 9.1 27.3 9.3 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.7 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.4999 18.7 15.3999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 8:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.210005 29.6037 -0.990001 22.9037 0.809999C13.6037 3.21 13.8037 8.61001 7.1037 11.01C0.403704 13.41 -1.19631 21.01 0.803686 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.91 40.4037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          />
          <path
            d="M16.9 22.7C16.9 21.9 17.1 21.2 17.4 20.6C17.7 20 18.2 19.4 18.8 18.9C19.4 18.4 20.1 18.1 20.9 17.8C21.7 17.5 22.6 17.4 23.6 17.4C24.6 17.4 25.5 17.5 26.3 17.8C27.1 18 27.8 18.4 28.4 18.8C29 19.2 29.4 19.8 29.8 20.4C30.1 21 30.3 21.7 30.3 22.5C30.3 23.4 30.1 24.1 29.8 24.8C29.4 25.4 29 26 28.3 26.4C29 26.9 29.6 27.5 30.1 28.2C30.6 28.9 30.8 29.8 30.8 31C30.8 31.8 30.6 32.5 30.3 33.1C30 33.7 29.5 34.3 28.9 34.8C28.3 35.3 27.5 35.6 26.6 35.9C25.7 36.2 24.7 36.3 23.6 36.3C22.5 36.3 21.5 36.2 20.6 35.9C19.7 35.6 19 35.3 18.4 34.8C17.8 34.3 17.3 33.8 17 33.1C16.7 32.5 16.5 31.7 16.5 31C16.5 29.9 16.7 29.1 17.2 28.4C17.7 27.7 18.2 27.2 18.8 26.8C18.3 26.4 17.8 25.9 17.5 25.3C17 24.5 16.9 23.7 16.9 22.7ZM21.4 30.5C21.4 31.1 21.6 31.6 22 31.9C22.4 32.3 22.9 32.4 23.5 32.4C24.1 32.4 24.6 32.2 25 31.9C25.4 31.5 25.6 31.1 25.6 30.5C25.6 29.9 25.4 29.5 25.1 29.1C24.8 28.7 24.3 28.4 23.7 28.2C22.8 28.4 22.2 28.7 21.9 29.1C21.6 29.5 21.4 29.9 21.4 30.5ZM25.3 22.9C25.3 22.4 25.1 22 24.8 21.6C24.5 21.3 24 21.1 23.5 21.1C22.9 21.1 22.5 21.3 22.2 21.6C21.9 21.9 21.7 22.3 21.7 22.8C21.7 23.3 21.9 23.7 22.2 24C22.5 24.3 22.9 24.6 23.3 24.8C24 24.6 24.5 24.4 24.8 24C25.2 23.7 25.3 23.3 25.3 22.9Z"
            fill="#3B180F"
          />
          <path
            d="M24.5998 14.9C24.3998 14.9 24.2998 14.8 24.2998 14.6V12.3C24.2998 12.1 24.3998 12 24.5998 12C24.7998 12 24.8998 12.1 24.8998 12.3V14.6C24.8998 14.8 24.7998 14.9 24.5998 14.9Z"
            fill="#3B180F"
          />
          <path
            d="M33.7999 18.7C33.6999 18.7 33.5999 18.7 33.5999 18.6C33.4999 18.5 33.4999 18.3 33.5999 18.2L35.1999 16.6C35.2999 16.5 35.4999 16.5 35.5999 16.6C35.6999 16.7 35.6999 16.9 35.5999 17L33.9999 18.6C33.8999 18.7 33.8999 18.7 33.7999 18.7Z"
            fill="#3B180F"
          />
          <path
            d="M39.8998 27.9H37.5998C37.3998 27.9 37.2998 27.8 37.2998 27.6C37.2998 27.4 37.3998 27.3 37.5998 27.3H39.8998C40.0998 27.3 40.1998 27.4 40.1998 27.6C40.1998 27.8 40.0998 27.9 39.8998 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M11.6 27.9H9.29999C9.09999 27.9 9 27.8 9 27.6C9 27.4 9.09999 27.3 9.29999 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.8 27.9 11.6 27.9Z"
            fill="#3B180F"
          />
          <path
            d="M15.3999 18.7C15.2999 18.7 15.1999 18.7 15.1999 18.6L13.5999 17C13.4999 16.9 13.4999 16.7 13.5999 16.6C13.6999 16.5 13.8999 16.5 13.9999 16.6L15.5999 18.2C15.6999 18.3 15.6999 18.5 15.5999 18.6C15.5999 18.7 15.4999 18.7 15.3999 18.7Z"
            fill="#3B180F"
          />
        </svg>
      )
    case 9:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.2037 4.41C33.2037 0.210005 29.6037 -0.990001 22.9037 0.809999C13.6037 3.21 13.8037 8.60999 7.10368 11.01C0.403679 13.41 -1.19631 21.01 0.803691 24.11C2.80369 27.21 6.50369 31.71 6.80369 38.71C7.20369 46.61 16.1037 50.31 25.9037 46.91C35.7037 43.51 36.1037 40.01 42.3037 38.91C51.8037 37.21 52.8037 24.01 44.9037 16.41C40.1037 11.91 40.5037 7.81 37.2037 4.41Z"
            fill="#FEB39C"
          ></path>
          <path
            d="M21.5003 32.2C22.7003 32.2 23.7003 31.9 24.5003 31.2C25.3003 30.6 25.6003 29.7 25.6003 28.5C25.4003 28.7 25.0003 28.9 24.4003 29.1C23.8003 29.3 23.1003 29.5 22.2003 29.5C21.3003 29.5 20.5003 29.4 19.8003 29.1C19.1003 28.8 18.4003 28.5 17.9003 28C17.4003 27.5 17.0003 26.9 16.7003 26.2C16.4003 25.5 16.3003 24.6 16.3003 23.7C16.3003 22.9 16.4003 22.1 16.7003 21.3C17.0003 20.5 17.4003 19.9 18.0003 19.3C18.6003 18.7 19.3003 18.3 20.2003 17.9C21.1003 17.6 22.1003 17.4 23.2003 17.4C25.5003 17.4 27.3003 18.2 28.6003 19.7C29.9003 21.2 30.6003 23.4 30.6003 26.3C30.6003 27.9 30.4003 29.3 30.0003 30.6C29.6003 31.8 29.0003 32.9 28.3003 33.7C27.6003 34.5 26.7003 35.1 25.7003 35.5C24.7003 35.9 23.6003 36.1 22.3003 36.1C20.7003 36.1 19.5003 35.9 18.6003 35.5C17.7003 35.1 17.3003 34.4 17.3003 33.5C17.3003 33.1 17.4003 32.7 17.6003 32.3C17.8003 31.9 18.0003 31.6 18.3003 31.4C18.8003 31.6 19.4003 31.8 20.0003 31.9C20.5003 32.2 21.1003 32.2 21.5003 32.2ZM23.4003 25.8C23.8003 25.8 24.1003 25.7 24.5003 25.6C24.9003 25.4 25.2003 25.2 25.5003 25V24.6C25.5003 23.5 25.3003 22.7 24.9003 22.2C24.5003 21.7 24.0003 21.4 23.3003 21.4C22.7003 21.4 22.2003 21.6 21.8003 22C21.4003 22.4 21.3003 22.9 21.3003 23.6C21.3003 24.3 21.5003 24.8 21.9003 25.2C22.2003 25.6 22.8003 25.8 23.4003 25.8Z"
            fill="#3B180F"
          ></path>
          <path
            d="M24.5002 14.9C24.3002 14.9 24.2002 14.8 24.2002 14.6V12.3C24.2002 12.1 24.3002 12 24.5002 12C24.7002 12 24.8002 12.1 24.8002 12.3V14.6C24.8002 14.8 24.7002 14.9 24.5002 14.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M33.6998 18.8C33.5998 18.8 33.4998 18.8 33.4998 18.7C33.3998 18.6 33.3998 18.4 33.4998 18.3L35.0998 16.7C35.1998 16.6 35.3998 16.6 35.4998 16.7C35.5998 16.8 35.5998 17 35.4998 17.1L33.8998 18.7C33.8998 18.7 33.7998 18.8 33.6998 18.8Z"
            fill="#3B180F"
          ></path>
          <path
            d="M39.8002 27.9H37.5002C37.3002 27.9 37.2002 27.8 37.2002 27.6C37.2002 27.4 37.3002 27.3 37.5002 27.3H39.8002C40.0002 27.3 40.1002 27.4 40.1002 27.6C40.1002 27.8 40.0002 27.9 39.8002 27.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M11.6 27.9H9.3C9.1 27.9 9 27.8 9 27.6C9 27.4 9.1 27.3 9.3 27.3H11.6C11.8 27.3 11.9 27.4 11.9 27.6C11.9 27.8 11.7 27.9 11.6 27.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M15.3999 18.8C15.2999 18.8 15.1999 18.8 15.1999 18.7L13.5999 17.1C13.4999 17 13.4999 16.8 13.5999 16.7C13.6999 16.6 13.8999 16.6 13.9999 16.7L15.5999 18.3C15.6999 18.4 15.6999 18.6 15.5999 18.7C15.4999 18.7 15.3999 18.8 15.3999 18.8Z"
            fill="#3B180F"
          ></path>
        </svg>
      )
    case 10:
      return (
        <svg
          width={props.width}
          height={props.height}
          viewBox="0 0 51 49"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M37.9039 4.41C33.9039 0.210005 30.3039 -0.990001 23.6039 0.809999C14.3039 3.21 14.5039 8.61 7.80387 11.01C1.10387 13.41 -0.496114 21.01 1.50389 24.11C3.50389 27.21 7.20389 31.71 7.50389 38.71C7.90389 46.61 16.8039 50.31 26.6039 46.91C36.4039 43.51 36.8039 40.01 43.0039 38.91C52.5039 37.21 53.5039 24.01 45.6039 16.41C40.8039 11.91 41.2039 7.81 37.9039 4.41Z"
            fill="#FEB39C"
          ></path>
          <path
            d="M25.2004 13.9C25.0004 13.9 24.9004 13.8 24.9004 13.6V11.3C24.9004 11.1 25.0004 11 25.2004 11C25.4004 11 25.5004 11.1 25.5004 11.3V13.6C25.5004 13.8 25.4004 13.9 25.2004 13.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M34.4 17.8C34.3 17.8 34.2 17.8 34.2 17.7C34.1 17.6 34.1 17.4 34.2 17.3L35.8 15.7C35.9 15.6 36.1 15.6 36.2 15.7C36.3 15.8 36.3 16 36.2 16.1L34.6 17.7C34.6 17.7 34.5 17.8 34.4 17.8Z"
            fill="#3B180F"
          ></path>
          <path
            d="M43.2001 26.9H40.9001C40.7001 26.9 40.6001 26.8 40.6001 26.6C40.6001 26.4 40.7001 26.3 40.9001 26.3H43.2001C43.4001 26.3 43.5001 26.4 43.5001 26.6C43.5001 26.8 43.4001 26.9 43.2001 26.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M12.3002 26.9H10.0002C9.8002 26.9 9.7002 26.8 9.7002 26.6C9.7002 26.4 9.8002 26.3 10.0002 26.3H12.3002C12.5002 26.3 12.6002 26.4 12.6002 26.6C12.6002 26.8 12.4002 26.9 12.3002 26.9Z"
            fill="#3B180F"
          ></path>
          <path
            d="M16.1001 17.8C16.0001 17.8 15.9001 17.8 15.9001 17.7L14.3001 16.1C14.2001 16 14.2001 15.8 14.3001 15.7C14.4001 15.6 14.6001 15.6 14.7001 15.7L16.3001 17.3C16.4001 17.4 16.4001 17.6 16.3001 17.7C16.2001 17.7 16.1001 17.8 16.1001 17.8Z"
            fill="#3B180F"
          ></path>
          <path
            d="M18.138 23.8L15.4271 24.7C15.1467 24.5 14.8663 24.2 14.5858 23.9C14.3054 23.5 14.2119 23.1 14.2119 22.4C14.2119 21.2 14.8663 20.4 16.1749 19.9L19.2597 18.8H20.288C21.0358 18.8 21.6902 19 22.1576 19.5C22.625 20 22.8119 20.7 22.8119 21.5V36.8C22.625 36.8 22.3445 36.9 21.8771 37C21.5032 37.1 21.1293 37.1 20.6619 37.1C20.288 37.1 19.9141 37.1 19.5402 37C19.2597 36.9 18.9793 36.8 18.6989 36.6C18.5119 36.4 18.3249 36.2 18.2315 35.9C18.138 35.6 18.0445 35.2 18.0445 34.7V23.8H18.138Z"
            fill="#3B180F"
          ></path>
          <path
            d="M24.3872 27.8526C24.3872 26.3925 24.5394 25.0298 24.9198 23.959C25.3003 22.7909 25.7568 21.8175 26.4416 21.1362C27.0503 20.3574 27.8111 19.7734 28.6481 19.384C29.485 18.9947 30.3981 18.8 31.3872 18.8C32.3763 18.8 33.2894 18.9947 34.1263 19.384C34.9633 19.7734 35.7242 20.3574 36.3329 21.1362C36.9416 21.9149 37.4742 22.8883 37.8546 23.959C38.235 25.1271 38.3872 26.3925 38.3872 27.8526C38.3872 29.3128 38.235 30.6755 37.8546 31.8436C37.4742 33.0117 37.0176 33.9851 36.4089 34.7638C35.8002 35.5425 35.0394 36.1266 34.2024 36.5159C33.3655 36.9053 32.3763 37.1 31.3872 37.1C30.3981 37.1 29.4089 36.9053 28.572 36.5159C27.735 36.1266 26.9742 35.5425 26.3655 34.7638C25.7568 33.9851 25.2242 33.0117 24.9198 31.8436C24.6155 30.5782 24.3872 29.3128 24.3872 27.8526ZM28.4198 27.8526C28.4198 29.6048 28.7242 30.8702 29.2568 31.7463C29.7894 32.6223 30.5502 33.0117 31.4633 33.0117C32.3763 33.0117 33.1372 32.6223 33.6698 31.7463C34.2024 30.8702 34.5068 29.6048 34.5068 27.8526C34.5068 26.1005 34.2024 24.8351 33.6698 23.959C33.1372 23.083 32.3763 22.6936 31.4633 22.6936C30.5502 22.6936 29.7894 23.083 29.2568 23.959C28.7242 24.8351 28.4198 26.1005 28.4198 27.8526Z"
            fill="#3B180F"
          ></path>
        </svg>
      )
    default:
      return null
  }
}
